import React from 'react';
import {
  Box,
  Container,
  Typography,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100vh',
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  },
  container:{
    height: '60%'
  }
}));

const BrowserNotSupport = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="404"
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="md" className={classes.container}>
          <Typography
            align="center"
            color="textPrimary"
            variant="h1"
          >
            Your Browser is not supported
          </Typography>
          <Typography
            align="center"
            color="textPrimary"
            variant="subtitle2"
          >
            Chrome Browser is the recommand broswer for using Combine Harvester
          </Typography>
          <Box textAlign="center" height="100%" pt={3}>
            <iframe src='https://www.google.com/intl/en_au/chrome/' width="100%" height="100%" frameBorder="0" />
          </Box>
        </Container>
      </Box>
    </Page>
  );
};

export default BrowserNotSupport;
